<template>
  <article v-if="charged">
    <section class="table_card mb-5">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9 >
            <p class="table_card__head--title">Editar Inmueble</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'location'})"
                class="breadcums__option">
                Locaciones creadas
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                @click="$router.push({name: 'location_edit', params: {id: $route.params.id}})"
                class="breadcums__option">
                {{ main_location }}
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable">
                Editar inmueble
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                :disabled="formIsInError"
                @click="formIsInError?'':editSublocation()"
              >
                Editar Inmueble
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>

      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12>
            <v-flex xs12 lg6 class="pr-3 mb-3">
              <span class="data_card__info--label">Seleccionar sublocación</span>
              <v-select
                label="Seleccionar inmueble"
                :items="sublocationList"
                item-value="id"
                item-text="name"
                v-model="selected_sublocation.id"
                single-line
                dense
                solo
                @change="selectSublocation()"
                color="blue bold"
              ></v-select>
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-3" v-if="selected_sublocation.id">
              <span class="data_card__info--label" style="white-space: nowrap;">Nombre del inmueble</span>
              <input
                class="faccess_input"
                type="text"
                name="Name"
                placeholder="Nombre del inmueble"
                v-model="selected_sublocation.name">
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-4" v-if="selected_sublocation.id">
              <span class="data_card__info--label" style="white-space: nowrap;">Propietario Asignado</span>
              <div style="display: flex; align-items: center; margin-top: 5px;">
                <div
                  class="faccess_input"
                  style="margin: 0; display: flex; align-items: center;">
                  {{ sublocation_user_name }}
                </div>
                <v-btn
                  v-show="!selecting_primary_user"
                  style="background-color: #1476FB; color: white;"
                  class="v-btn ml-3"
                  @click="activeUserSelection('primary_user')">
                  Editar
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-3" v-if="selected_sublocation.id">
              <span class="data_card__info--label" style="white-space: nowrap;">Usuarios Relacionados</span>
              <div style="display: flex; margin-top: 5px;">
                <div
                  class="faccess_input"
                  style="margin: 0; padding-bottom: 0; display: flex; flex-direction: column; height: 130px; overflow-y: auto;">

                  <span
                    v-for="assigned_user in sublocation_assigned_user_names"
                    style="margin-bottom: 10px;">
                    - {{ assigned_user }}
                  </span>
                </div>
                <v-btn
                  v-show="!selecting_assigned_users"
                  style="background-color: #1476FB; color: white;"
                  class="v-btn ml-3"
                  @click="activeUserSelection('assigned_users')">
                  Editar
                </v-btn>
              </div>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
    </section>

    <section class="table_card mb-5" v-show="selecting_primary_user || selecting_assigned_users">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              {{ selecting_primary_user ? 'Seleccionar propietario asignado' : 'Seleccionar usuarios relacionados' }}
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right">
              <input
                type="text"
                placeholder="Buscar"
                class="input_solid"
                v-model="options_table.search"
              >
              <img
                src="@/assets/img/icons/search-icon.svg"
                class="button_search"
              >
            </v-flex>
            <div
              class="buttom_reload"
              @click="selecting_primary_user ? getUsersForSublocation() : getUsersToNotifySublocation()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div>

        <v-data-table
          :headers="options_table.headers_table"
          :items="filteredUsers"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          hide-actions
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th></th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                <v-checkbox
                  :input-value="(selecting_primary_user && selected_sublocation.user_id == props.item.id) ||
                                (selecting_assigned_users && sublocation_assigned_users.includes(props.item.id))"
                  color="#1476FB"
                  hide-details
                  @change="selectUser(props.item)"
                ></v-checkbox>
              </td>
              <td class="text-xs-center" width="180px">{{ props.item.rut }}</td>
              <td class="text-xs-center">{{ props.item.name }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination :value="page" :length="pages" @input="changePage"></v-pagination>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return {
      charged: false,
      page: 0,
      pages: 1,
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 20
        },
        headers_table:[
          {
            text: 'N° Documento',
            align: 'center',
            value: 'rut'
          },
          {
            text: 'Nombre Usuario',
            align: 'center',
            value: 'name'
          }
        ],
        filters: {
          rut: [],
          name: [],
        },
      },
      selecting_primary_user: false,
      selecting_assigned_users: false,
      users_for_select: [],
      users_to_notify_sublocation_for_select: [],
      main_location: '',
      sublocations: [],
      selected_sublocation: {
        id: '',
        name: '',
        user_id: '',
        owner: null,
        assigned_users: []
      },
      sublocation_user_name: '',
      sublocation_assigned_users: [],
      sublocation_assigned_user_names: []
    }
  },
  computed: {
    sublocationList(){
      return this.sublocations.map(sub => {
        return {
          id: sub.id,
          name: sub.attributes.name
        }
      })
    },
    filteredUsers(){
      let res = []

      if(this.selecting_primary_user){
        res = this.users_for_select.filter(d => {
          return Object.keys(this.options_table.filters).every(f => {
            return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
          })
        })
        res = this.selected_sublocation.owner ? [this.selected_sublocation.owner, ...res] : res

      } else if(this.selecting_assigned_users){
        res = this.users_to_notify_sublocation_for_select.filter(d => {
          return Object.keys(this.options_table.filters).every(f => {
            return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
          })
        })
        res = [...this.selected_sublocation.assigned_users, ...res]
      }

      return res
    },
    formIsInError(){
      return this.selected_sublocation.name.length == 0
    }
  },
  methods: {
    selectUser({id, name}){
      if(this.selecting_primary_user){
        if(this.selected_sublocation.user_id != id){
          this.selecting_primary_user = false
          this.selected_sublocation.user_id = id
          // this.selected_sublocation.owner.name = name
          this.sublocation_user_name = name

        } else {
          this.selected_sublocation.user_id = ''
          this.sublocation_user_name = ''
        }

      } else if(this.selecting_assigned_users){
        if(!this.sublocation_assigned_users.includes(id)){
          this.sublocation_assigned_users.push(id)
          this.sublocation_assigned_user_names.push(name)

        } else {
          this.sublocation_assigned_users.splice(this.sublocation_assigned_users.indexOf(id), 1)
          this.sublocation_assigned_user_names.splice(this.sublocation_assigned_user_names.indexOf(name), 1)
        }
      }
    },
    selectSublocation(){
      this.selecting_primary_user = false
      this.selecting_assigned_users = false

      this.sublocations.forEach(sub => {
        if(sub.id == this.selected_sublocation.id){
          this.selected_sublocation.name = sub.attributes.name
          this.selected_sublocation.user_id = sub.attributes.user_id
          this.selected_sublocation.owner = sub.attributes.owner
          this.selected_sublocation.assigned_users = sub.attributes.assigned_users
          this.sublocation_user_name = sub.attributes.owner ? sub.attributes.owner.name : ''
          this.sublocation_assigned_user_names = this.selected_sublocation.assigned_users.map(usr => usr.name)
          this.sublocation_assigned_users = this.selected_sublocation.assigned_users.map(usr => usr.id)
        }
      })
    },
    getSublocations(){
      try {
        this.$http.get('app/sublocations/find_by_location', {
          params: {
            location_id: this.$route.params.id
          },
          headers: {
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        }).then(response => {
          this.sublocations = response.body.data
          this.main_location = this.sublocations[0].attributes.location.name
          this.getUsersForSublocation()
          this.getUsersToNotifySublocation()
          this.charged = true
        })
      } catch(e){
        console.log(e)
      }
    },
    getUsersForSublocation(){
      try {
        this.$http.get('app/sublocations/get_active_users_for_sublocation',{
          params: {
            page: this.page,
            company_id: this.getCompany().id,
            location_id: this.$route.params.id
          },

          headers: {
            "X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.users_for_select = response.body.data
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    getUsersToNotifySublocation(){
      try {
        this.$http.get('app/sublocations/users_to_notify_sublocation',{
          params: {
            company_id: this.getCompany().id,
            page: this.page,
            location_id: this.$route.params.id
          },

          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          },
        })
        .then(function(response){
          this.users_to_notify_sublocation_for_select = response.body.data
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editSublocation(){
      const sublocationData = {
        name: this.selected_sublocation.name,
        user_id: this.selected_sublocation.user_id,
        assigned_users: this.sublocation_assigned_users
      }

      console.log(sublocationData)

      try {
        this.$http.put('app/sublocations', {
          data: this.encrypt(sublocationData).toString()
        },
        {
          params: {
            sublocation_id: this.selected_sublocation.id
          },
          headers: {
            "Authorization": 'Bearer ' + this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }
        }).then(response => {
          if(response.status == 200){
            this.$router.push({name: 'location_edit', params: {id: response.body.data.attributes.location_id}})
            this.updateAlertMessage("Inmueble editado correctamente")
            this.updateIsInAlert(true)
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })

      } catch(e){
        console.log(e)
      }
    },
    activeUserSelection(ref){
      if(ref == 'primary_user'){
        this.selecting_primary_user = true
        this.selecting_assigned_users = false

      } else if(ref == 'assigned_users'){
        this.selecting_assigned_users = true
        this.selecting_primary_user = false
      }

      scrollTo(0, 700)
      this.changePage(1)
    },
    changeSort(column){
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    changePage(page){
      this.page = page

      if(this.selecting_primary_user) this.getUsersForSublocation()
      else if(this.selecting_assigned_users) this.getUsersToNotifySublocation()
    }
  },
  mounted(){
    this.getSublocations()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/EditSublocationFromLocation.vue